export function matchPattern(params: string | string[], searchPattern: string): boolean;
export function matchPattern(params: string | string[], searchPattern: string) {
  let compareWith: string[] = [];

  if (typeof searchPattern === 'undefined' || searchPattern === null || !searchPattern?.length) {
    return true;
  }

  if (!Array.isArray(params)) {
    compareWith = [params];
  } else {
    compareWith = [...params];
  }

  const patternEscaped = `${searchPattern}`.trim().replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');

  return compareWith.some(param => {
    return `${param}`.search(new RegExp(patternEscaped, 'i')) >= 0;
  });
}
